import { render } from "./MainGiaiPhapChuyenDoiSo.vue?vue&type=template&id=3e65bceb"
import script from "./MainGiaiPhapChuyenDoiSo.vue?vue&type=script&lang=js"
export * from "./MainGiaiPhapChuyenDoiSo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__